/** Bump when you ship frontend changes — confirms users load the new JS bundle. */
export const APP_UI_VERSION = '2026.08.15';
